import PropTypes from 'prop-types';
import sessionFeePropTypes from './sessionFeePropTypes';

// For old API response, not GraphQL
const sessionPropTypes = PropTypes.shape({
    code: PropTypes.string,
    fees: PropTypes.arrayOf(sessionFeePropTypes),
    maximum_attendance: PropTypes.number,
    seats_remaining: PropTypes.number,
    title: PropTypes.string,
});

export default sessionPropTypes;
